export default __webpack_public_path__ + "static/media/icon-downloads.6680399c.svg";